export function formatDisplay(value) {
    if (value === null || value === undefined || isNaN(Number(value))) return '';
    return Number(value).toLocaleString(undefined, {
        maximumFractionDigits: 2,
    });
}